import { setSubroute } from 'store/navbar'
import { UserIsAuthenticated, UserHasValidPassword, UserHasScope } from 'containers/authContainers'
import LockRedirect from 'containers/lockContainers'
import { injectReducers } from 'store/reducers'
import { setPageTitle } from 'utils/misc'
import VisitContainer from '../VisitPage/container/VisitContainer'
import templateVisitReducer from '../VisitPage/modules/TemplateVisit'
import { visitTemplateActions } from '../VisitTemplatePage/modules/VisitTemplate'

export const injectVisitReducers = store => {
  injectReducers(store, {
    templateVisitReducer,
  })
}

// Sync route definition
export default store => ({
  path: 'visits/:templateVisitId/:parentScheduleId/edit',
  exact: true,
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure(
      [],
      () => {
        const { studyID, parentScheduleId, templateVisitId, studyVersionID } = nextState.params
        injectVisitReducers(store)
        store.dispatch(setSubroute('visits'))
        store.dispatch(visitTemplateActions.fetchVisitTemplate(studyID, parentScheduleId, templateVisitId))
        /*  Webpack - use require callback to define
         dependencies for bundling   */

        const { study } = store.getState()
        const { currentStudy } = study
        setPageTitle(`Edit Visit | Study ${studyID} | ${currentStudy.platform_name}`)

        /*  Return getComponent   */
        cb(
          null,
          UserIsAuthenticated(
            UserHasValidPassword(
              LockRedirect(
                studyID,
                studyVersionID,
                'visit-schedules',
              )(UserHasScope(['wpv'], VisitContainer, true, studyID)),
            ),
          ),
        )

        /* Webpack named bundle   */
      },
      'visit-templates',
    )
  },
})
